module.exports = __webpack_public_path__ + "img/car_00056.94dd4b28.jpg";